let sensors

export const sensorEventTypes = {
  UNLOCKWALLETCONNECTSUCCEED: 'Unlock_Wallet_Connect_Succeed',
  UNLOCKLEDGERSUCCEED: 'Unlock_Ledger_Succeed',
  UNLOCKKEYSTOREFILESUCCEED: 'Unlock_Keystore_File_Succeed',
  UNLOCKMNEMONICPHRASESUCCEED: 'Unlock_Mnemonic_Phrase_Succeed',
  PLACEORDERSUCCESS: 'Buy & Sell',
  TRADEOPENORDERS: 'Open Orders',
  TRADEORDERHISTORY: 'Order History',
  TRADETRADEHISTORY: 'Trade History',
  TRADEBALANCES: 'Balances',
}

export const setSensors = data => {
  sensors = data
}

export const getSensors = () => sensors

export const track = (event, data) => {
  if (sensors) {
    sensors.track(event, data)
  }
}

export const login = userId => {
  if (sensors) {
    sensors.login(userId)
  }
}
